import { render, staticRenderFns } from "./PaiAll.vue?vue&type=template&id=8131eb0e&"
import script from "./PaiAll.vue?vue&type=script&lang=js&"
export * from "./PaiAll.vue?vue&type=script&lang=js&"
import style0 from "./PaiAll.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports